import React from 'react'

import { GrowthBookProvider } from '@growthbook/growthbook-react'

export const ExperimentProviderWrapper = ({ experimentObj, children }) => (
  <GrowthBookProvider growthbook={experimentObj}>{children}</GrowthBookProvider>
)
